class CarouselBuilder extends HTMLElement {
  constructor() {
    super();
    this.steps = [...this.querySelectorAll('.carousel-builder__step')];
    this.panels = [...this.querySelectorAll('.carousel-builder__panel')];
    this.summaryItems = this.querySelector('.carousel-builder__summary-items');
    this.summaryTotal = this.querySelector('.carousel-builder__summary-total span:last-child');
    this.addBtn = this.querySelector('.carousel-builder__add-btn');
    this.navBtns = this.querySelectorAll('.carousel-builder__nav-btn');
    this.currentStep = 0;
    this.bindEvents();
    this.updateSummary();
  }

  bindEvents() {
    this.steps.forEach((step, i) => {
      step.addEventListener('click', () => this.goToStep(i));
    });

    this.navBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const dir = btn.dataset.dir;
        if (dir === 'next') this.goToStep(this.currentStep + 1);
        else if (dir === 'prev') this.goToStep(this.currentStep - 1);
      });
    });

    this.querySelectorAll('.carousel-builder__qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.parentElement.querySelector('.carousel-builder__qty-input');
        let val = parseInt(input.value) || 0;
        if (btn.classList.contains('carousel-builder__qty-btn--minus')) {
          input.value = Math.max(0, val - 1);
        } else {
          input.value = val + 1;
        }
        this.updateSummary();
      });
    });

    this.querySelectorAll('.carousel-builder__qty-input').forEach(input => {
      input.addEventListener('change', () => {
        if (parseInt(input.value) < 0) input.value = 0;
        this.updateSummary();
      });
    });

    this.querySelectorAll('.carousel-builder__color-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const row = btn.closest('.carousel-builder__variant-row, .addon-card');
        row.querySelectorAll('.carousel-builder__color-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const variantId = btn.dataset.variantId;
        const price = btn.dataset.price;
        if (variantId) row.dataset.selectedVariant = variantId;
        if (price) {
          row.dataset.selectedPrice = price;
          const priceEl = row.querySelector('.carousel-builder__variant-price, .addon-card__price-value');
          if (priceEl) priceEl.textContent = this.formatMoney(parseInt(price));
        }

        const image = btn.dataset.image;
        if (image) {
          const img = row.querySelector('img');
          if (img) img.src = image;
        }

        this.updateSummary();
      });
    });

    if (this.addBtn) {
      this.addBtn.addEventListener('click', () => this.addAllToCart());
    }
  }

  goToStep(index) {
    if (index < 0 || index >= this.steps.length) return;
    this.currentStep = index;
    this.steps.forEach((s, i) => s.classList.toggle('active', i <= index));
    this.panels.forEach((p, i) => p.classList.toggle('active', i === index));
  }

  getSelectedItems() {
    const items = [];
    this.querySelectorAll('.carousel-builder__variant-row').forEach(row => {
      const qty = parseInt(row.querySelector('.carousel-builder__qty-input')?.value) || 0;
      if (qty < 1) return;
      const variantId = row.dataset.selectedVariant;
      const price = parseInt(row.dataset.selectedPrice) || 0;
      const name = row.querySelector('.carousel-builder__variant-name')?.textContent?.trim();
      const activeColor = row.querySelector('.carousel-builder__color-btn.active');
      const colorName = activeColor?.title || '';
      items.push({ variantId, price, qty, name, colorName });
    });
    return items;
  }

  updateSummary() {
    if (!this.summaryItems) return;
    const items = this.getSelectedItems();

    if (items.length === 0) {
      this.summaryItems.innerHTML = '<li class="empty-msg">Select items above to build your bundle</li>';
      if (this.summaryTotal) this.summaryTotal.textContent = '$0.00';
      if (this.addBtn) this.addBtn.disabled = true;
      return;
    }

    if (this.addBtn) this.addBtn.disabled = false;
    this.summaryItems.innerHTML = '';
    let total = 0;

    items.forEach(item => {
      const lineTotal = item.price * item.qty;
      total += lineTotal;
      const li = document.createElement('li');
      const label = item.colorName ? `${item.name} (${item.colorName})` : item.name;
      li.innerHTML = `<span>${label} × ${item.qty}</span><span>${this.formatMoney(lineTotal)}</span>`;
      this.summaryItems.appendChild(li);
    });

    if (this.summaryTotal) this.summaryTotal.textContent = this.formatMoney(total);
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  async addAllToCart() {
    const items = this.getSelectedItems().filter(i => i.variantId);
    if (items.length === 0) return;

    this.addBtn.disabled = true;
    const origText = this.addBtn.textContent;
    this.addBtn.textContent = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: items.map(i => ({ id: parseInt(i.variantId), quantity: i.qty }))
        }),
      });

      if (!res.ok) throw new Error('Failed');

      fetch('/cart.js').then(r => r.json()).then(cart => {
        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (cartIcon) {
          let bubble = cartIcon.querySelector('.cart-count-bubble');
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
            cartIcon.appendChild(bubble);
          }
          const spans = bubble.querySelectorAll('span');
          if (spans[0]) spans[0].textContent = cart.item_count;
          if (spans[1]) spans[1].textContent = cart.item_count + ' items';

          const svgWrappers = cartIcon.querySelectorAll('.svg-wrapper');
          if (svgWrappers.length === 2) {
            svgWrappers[0].style.display = 'none';
            svgWrappers[1].style.display = '';
          }
        }
        document.querySelectorAll('cart-notification, cart-drawer').forEach(el => {
          if (typeof el.renderContents === 'function') el.renderContents(cart);
        });
      });

      this.addBtn.textContent = 'Added to cart!';
      setTimeout(() => { this.addBtn.textContent = origText; this.addBtn.disabled = false; }, 2500);
    } catch (e) {
      this.addBtn.textContent = 'Error — try again';
      setTimeout(() => { this.addBtn.textContent = origText; this.addBtn.disabled = false; }, 2500);
    }
  }
}

customElements.define('carousel-builder', CarouselBuilder);
